<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.DRUG' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.DRUG' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="drugForm">
        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DRUG_NAME' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.DRUG_NAME' | translate }}" formControlName="name">
                    <mat-error *ngIf="drugForm.get('name')?.hasError('required') && 
                    (drugForm.get('name')?.dirty || drugForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="drugForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.GENERIC_NAME' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.GENERIC_NAME' | translate }}" formControlName="genericName">
                    <mat-error *ngIf="drugForm.get('genericName')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DRUG_TYPE' | translate }}</mat-label>
                    <input type="text" matInput placeholder="Search Drug Type" [matAutocomplete]="autotype"
                        [formControl]="drugTypeCtrl" />

                    <mat-autocomplete #autotype="matAutocomplete" [displayWith]="displayDrugType"
                        (optionSelected)="onDrugTypeSelected($event.option.value)">
                        <!-- <mat-option *ngIf="showAddOptionfortype" class="text-primary">
                            <strong>Add "{{ drugTypeCtrl.value }}"</strong>
                        </mat-option> -->
                        <mat-option *ngFor="let item of filteredDrugType$ | async" [value]="item">
                            {{ item.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="drugTypeCtrl.hasError('required') && 
                    (drugTypeCtrl.dirty || drugTypeCtrl.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DRUG_COMPANY' | translate }}</mat-label>
                    <input type="text" matInput placeholder="Search Drug Company" [matAutocomplete]="autocompany"
                        [formControl]="drugcompanyCtrl" />

                    <mat-autocomplete #autocompany="matAutocomplete" [displayWith]="displayDrugcompany"
                        (optionSelected)="onDrugCompanySelected($event.option.value)">
                        <mat-option *ngFor="let company of filteredDrugCompany$ | async" [value]="company">
                            {{ company.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DRUG_CONTENT' | translate }}</mat-label>
                    <input type="text" matInput placeholder="Search drug content" [matAutocomplete]="genericAuto"
                        [formControl]="genericcontentCtrl" [value]="selectedGenericNames.join(', ')" />
                    <mat-autocomplete #genericAuto="matAutocomplete" [displayWith]="displayGenericContent">
                        <mat-option *ngFor="let generic of filteredGenericContent$ | async" [value]="generic"
                            (onSelectionChange)="toggleSelection($event, generic)">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelection($event, generic)"
                                [checked]="isSelected(generic)">
                                {{ generic.name }}
                            </mat-checkbox>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DESCRIPTION_LABEL' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.DESCRIPTION_LABEL' | translate }}" cols="5" rows="3"
                        formControlName="instructions"></textarea>
                    <!-- <mat-error *ngIf="clinicalItemForm.get('description')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>-->
                    <mat-error *ngIf="drugForm.get('instructions')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM255' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onUpdateDrug()" *ngIf="isEdit"
                [disabled]="drugForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onSaveDrug()" *ngIf="!isEdit"
                [disabled]="drugForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>